import ca from './ca.json';
import en from './en.json';
import es from './es.json';
import eu from './eu.json';
import pt from './pt-PT.json';

export default { en, ca, es, eu, pt };
